
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13 26c6.627 0 12-5.373 12-12S19.627 2 13 2 1 7.373 1 14s5.373 12 12 12zm0-3a9 9 0 100-18 9 9 0 000 18z","fill":"#1BBAC8"}}),_c('path',{attrs:{"d":"M24.5 14c0 6.351-5.149 11.5-11.5 11.5v1c6.904 0 12.5-5.596 12.5-12.5h-1zM13 2.5c6.351 0 11.5 5.149 11.5 11.5h1c0-6.904-5.596-12.5-12.5-12.5v1zM1.5 14C1.5 7.649 6.649 2.5 13 2.5v-1C6.096 1.5.5 7.096.5 14h1zM13 25.5C6.649 25.5 1.5 20.351 1.5 14h-1c0 6.904 5.596 12.5 12.5 12.5v-1zM21.5 14a8.5 8.5 0 01-8.5 8.5v1a9.5 9.5 0 009.5-9.5h-1zM13 5.5a8.5 8.5 0 018.5 8.5h1A9.5 9.5 0 0013 4.5v1zM4.5 14A8.5 8.5 0 0113 5.5v-1A9.5 9.5 0 003.5 14h1zm8.5 8.5A8.5 8.5 0 014.5 14h-1a9.5 9.5 0 009.5 9.5v-1z","fill":"#393939"}}),_c('path',{attrs:{"d":"M13 8v6h5","stroke":"#393939","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M11.552 30.5l-.009-.003c-.009-.004-.021-.012-.032-.033a.11.11 0 01-.008-.072l.051-.2c.065-.25.148-.572.23-.952.132-.482.466-1.349 1.021-2.587.582-1.22 1.262-2.33 2.036-3.264h0l.006-.007c.75-.937 1.879-1.802 3.383-2.582h0l.006-.002c1.3-.694 2.77-1.093 4.347-1.16l.479-.02v-4.027c0-.033.013-.066.044-.09h.007l.045-.001a.21.21 0 01.044.004l.008.007 8.245 7.409.018.015.015.012.003.005A.12.12 0 0131.5 23a.12.12 0 01-.012.053l-.008.006-.011.01-8.256 6.9a.47.47 0 01-.08.04.365.365 0 01-.034-.014.16.16 0 01-.061-.052.072.072 0 01-.012-.024v-4.643l-.506.007c-2.69.035-4.864.35-6.453.972-1.727.648-3.17 2.111-4.425 4.21l-.017.028a.151.151 0 01-.046.007h-.027z","fill":"#393939","stroke":"#fff"}})])
          )
        }
      }
    